import { testimonials } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

const avatarColors = [
  'bg-primary-100 text-primary-700',
  'bg-secondary-100 text-secondary-800',
  'bg-accent-100 text-accent-700',
  'bg-primary-100 text-primary-700',
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          {/* 品牌介绍 */}
          <div>
            <SectionHeading
              eyebrow="关于我们"
              title="把每天的热闹，讲给你听"
              desc="吃瓜大全是一群热爱分享的“互联网原住民”共同维护的热门事件合集。我们相信，信息不该是零散的噪音，而应该被清晰地整理、真实地呈现。"
              accentIcon="ri-heart-line"
            />
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              从成立之初，我们就坚持“一站在手吃瓜不愁”的初衷：早间速览、午间追踪、晚间打包，把今日汇总、最新瓜料与热点事件整理得清清楚楚。我们不生产耸人听闻的标题，只做负责任的搬运与求证。
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {[
                { v: '24h', l: '全年在线' },
                { v: '8 大', l: '核心栏目' },
                { v: '100%', l: '真实求是' },
              ].map((s) => (
                <div key={s.l} className="rounded-2xl border border-background-200 bg-background-50 p-4 text-center">
                  <p className="font-heading text-2xl font-bold text-primary-600">{s.v}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 口碑 */}
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">瓜友们都这么说</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((t, i) => (
                <figure
                  key={t.name}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:shadow-card"
                >
                  <div className="flex text-primary-500">
                    {Array.from({ length: 5 }).map((_, k) => (
                      <i key={k} className="text-sm ri-star-fill" />
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span
                      className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-base font-bold ${avatarColors[i]}`}
                    >
                      {t.initial}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}